import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import { H3, H4, H6, Body1 } from '@components/Text'

import { Button } from '@gympass/yoga'

export const PlanCardWrapper = styled.section`
  background: #ffffff;
  border-radius: 16px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    padding: 24px;
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.08);
  }
`

export const Title = styled(H4)`
  font-style: normal;
  font-weight: 900;
  line-height: 32px;
`
export const Price = styled(H3)`
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 32px;
  color: ${props => props.color || 'var(--sao-paulo-60);'}
  margin-top: 8px;

  i {
    font-weight: normal;
    font-style: normal;
    font-size: 28px;
    line-height: 32px;
    color: ${props => props.iconColor || 'var(--sao-paulo-60);'}
  }

  em {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #001027;
    margin-left: 3px;
  }
`

export const DividerWrapper = styled.section`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const OfferList = styled.section`
  display: flex;
  flex-direction: column;
`

export const OfferItem = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const OfferDescription = styled(Body1)`
  line-height: 16px;
`

export const OfferValue = styled(H6)`
  line-height: 19px;
  font-weight: 700;
`

export const CardFooter = styled.section`
  margin-top: 8px;
`

export const ButtonText = styled(H6)`
  line-height: 19px;
  font-weight: 700;
`
export const ButtonOutline = styled(Button.Outline)`
  ${({ customTheme }) => `
    border-color: ${customTheme.borderColor || '#1453A0;'}
    border: ${customTheme.border || '2px solid #1453A0;'}
    color: ${customTheme.color || '#1453A0;'}

    &:focus {
      background-color: ${customTheme.focus.backgroundColor ||
        'rgba(20, 83, 160, 0.3);'}
    }

    &:hover {
      background-color: ${customTheme.hover.backgroundColor ||
        'rgba(20, 83, 160, 0.3);'}
    }

    &:active {
      border-color: ${customTheme.active.borderColor || '#1968C9;'}
      border: ${customTheme.active.border || '2px solid #1968C9;'}
      color: ${customTheme.active.color || '#1968C9;'}
      background-color: ${customTheme.active.backgroundColor || 'transparent;'}
    }
  `}
`
